import React from 'react';
import { Input } from '../../ui/input';

/** Numeric input synchronised with a Slider. Presentational only. */
export const NumericField = ({ testId, value, onChange, prefix = '', suffix = '', step = 1 }) => (
  <div className="relative">
    {prefix && (
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 dark:text-slate-400 text-sm pointer-events-none">
        {prefix}
      </span>
    )}
    <Input
      data-testid={testId}
      type="number"
      value={Number.isFinite(value) ? value : 0}
      step={step}
      onChange={(e) => {
        const raw = e.target.value;
        const n = raw === '' ? 0 : Number(raw);
        if (Number.isFinite(n)) onChange(n);
      }}
      className={`bg-white dark:bg-[#0F1419] text-slate-900 dark:text-slate-100 border-slate-200 dark:border-slate-700 h-10 w-full font-mono ${prefix ? 'pl-7' : ''} ${suffix ? 'pr-10' : ''}`}
    />
    {suffix && (
      <span className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 dark:text-slate-400 text-sm pointer-events-none">
        {suffix}
      </span>
    )}
  </div>
);

export default NumericField;
